import { addFiles, archiveFiles, deleteFiles, editFile, shareFile, unShareFile } from './file.action';
import { getFiles } from './file.action';

export { fileReducer } from './file.reducer';
export { watchFiles } from './file.saga';

export const fileActions = {
    getFiles,
    addFiles,
    editFile,
    deleteFiles,
    archiveFiles,
    shareFile,
    unShareFile,
};
